import { render, staticRenderFns } from "./adminDatatable.vue?vue&type=template&id=47279be2&scoped=true&"
import script from "./adminDatatable.vue?vue&type=script&lang=js&"
export * from "./adminDatatable.vue?vue&type=script&lang=js&"
import style0 from "./adminDatatable.vue?vue&type=style&index=0&id=47279be2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47279be2",
  null
  
)

export default component.exports